import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext({ theme: "blakes", cycle: () => {}, setTheme: () => {} });

export const THEMES = ["blakes", "bold", "editorial"];
export const THEME_LABELS = {
  blakes: "Blakes",
  bold: "Bold",
  editorial: "Editorial",
};

function readInitialTheme() {
  if (typeof window === "undefined") return "blakes";
  try {
    const saved = window.localStorage.getItem("cm_theme");
    if (THEMES.includes(saved)) return saved;
  } catch (_) {}
  return "blakes";
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(readInitialTheme);

  useEffect(() => {
    try {
      window.localStorage.setItem("cm_theme", theme);
    } catch (_) {}
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);

  const cycle = () =>
    setTheme((t) => {
      const i = THEMES.indexOf(t);
      return THEMES[(i + 1) % THEMES.length];
    });

  return (
    <ThemeContext.Provider value={{ theme, cycle, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
